import React from "react";
import { SiLinkedin, SiGithub, SiGmail } from "react-icons/si";
import { Animate } from "react-simple-animate";
import "./styles.scss";

const Home = () => {

  return (
    <section id="home" className="home">
      <div className="home__text-wrapper">
        <h1>
          Hello, မင်္ဂလာပါ, こんにちは ...<br />
          I'm Myat Myint Zu Thin, AI engineer
        </h1>
      </div>
      <Animate
        play
        duration={1.5}
        delay={1}
        start={{
          transform: "translateY(550px)",
        }}
        end={{
          transform: "translatex(0px)",
        }}
      >
        <div className="home__icon-buttons">
          <a href="https://myatmyintzuthin99@gmail.com" target="_blank" rel="noreferrer">
            <button>< SiGmail /></button>
          </a>
          <a href="https://www.linkedin.com/in/myat-myint-zu-thin-93360714a/" target="_blank" rel="noreferrer">
            <button>< SiLinkedin /></button>
          </a>
          <a href="https://github.com/myatmyintzuthin" target="_blank" rel="noreferrer">
            <button>< SiGithub /></button>
          </a>
        </div>
        <div className="home__buttons">
          <a href="#about">
            <button>About Me</button>
          </a>
          <a href="#skills">
            <button>Skills</button>
          </a>
          <a href="#resume">
            <button>Resume</button>
          </a>
          <a href="#portfolio">
            <button>Projects</button>
          </a>
        </div>

        
        
      </Animate>
    </section>

    
  );
};
export default Home;
